import React from 'react'
import { Play } from 'lucide-react'
import ReasoningLoader from 'pages/recap/ReasoningLoader'
import SessionVideo from 'pages/recap/SessionVideo'

type SessionPlaybackProps = {
  primaryVideoUrl?: string
  videoPoster?: string
}

const SessionPlayback: React.FC<SessionPlaybackProps> = ({
  primaryVideoUrl,
  videoPoster
}) => {
  const renderContent = () => {
    if (primaryVideoUrl) {
      return (
        <SessionVideo
          primaryVideoUrl={primaryVideoUrl}
          videoPoster={videoPoster}
        />
      )
    } else {
      return (
        <ReasoningLoader
          statements={[
            'Processing recorded video data...',
            'Extracting visual and audio cues...',
            'Enhancing video clarity and quality...',
            'Compiling session highlights...',
            'Finalizing video for review...'
          ]}
          intervalMs={1500}
          minStatements={5}
          shouldComplete={!!primaryVideoUrl}
        />
      )
    }
  }

  return (
    <div className='bg-white rounded-lg shadow-sm p-6 mb-6'>
      <div className='flex items-center gap-2 mb-4'>
        <Play className='text-blue-500' size={20} />
        <h2 className='text-lg font-semibold text-gray-900'>
          Session Playback
        </h2>
      </div>

      {renderContent()}
    </div>
  )
}

export default SessionPlayback
